
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Client, ClientOnboardingStatus } from 'ah-api-gateways';
import StatusPill from 'ah-common-lib/src/common/components/StatusPill.vue';

@Component({
  components: {
    StatusPill,
  },
})
export default class ClientOnboardingStatusPill extends Vue {
  @Prop({ required: true }) client!: Client;

  get statusColors(): {
    [key in ClientOnboardingStatus]: string;
  } {
    return {
      [ClientOnboardingStatus.CREATED]: 'grey',
      [ClientOnboardingStatus.PENDING]: 'warning',
      [ClientOnboardingStatus.APPROVED]: 'success',
      [ClientOnboardingStatus.REJECTED]: 'danger',
    };
  }

  get statusLabels(): {
    [key in ClientOnboardingStatus]: string;
  } {
    return {
      [ClientOnboardingStatus.CREATED]: 'Info required',
      [ClientOnboardingStatus.PENDING]: 'In-review',
      [ClientOnboardingStatus.APPROVED]: 'Approved',
      [ClientOnboardingStatus.REJECTED]: 'Rejected',
    };
  }
}
